import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=2747858a&scoped=true&"
import script from "./FaqForm.vue?vue&type=script&lang=ts&"
export * from "./FaqForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2747858a",
  null
  
)

export default component.exports